<template>
    <LayoutForm>
        <div class="loading" v-if="$wait.is('event')">
            <Spinner :height="40" :width="40"/>
        </div>
        <template v-else>
            <template v-if="error">
                <button type="button"></button>
            </template>
            <template v-else>
                <div class="form__title" v-if="id">
                    <h1>
                        <span v-if="formData.event">{{ formData.event.eventName }}</span>
                        <span>Edit Activity</span>
                    </h1>
                </div>
                <div class="form__title" v-else>
                    <h1>
                        <span v-if="formData.event">{{ formData.event.eventName }}</span>
                        <span>Create Activity</span>
                    </h1>
<!--                    <pre>{{ JSON.stringify({-->
<!--                        startDate: startDate,-->
<!--                        endDate: endDate,-->
<!--                        eventStartDate: eventStartDate,-->
<!--                        eventEndDate: eventEndDate,-->
<!--                        selectedStart: formData.start,-->
<!--                        selectedEnd: formData.end,-->
<!--                    }, null, 2) }}</pre>-->
<!--                    <pre>{{JSON.stringify(this.formData.event.start, null, 2)}}</pre>-->
<!--                    <pre>-->
<!--                        {{ JSON.stringify(start, null, 2) }}-->
<!--                    </pre>-->
<!--                    <pre>-->
<!--                        {{ isValid ? "true" : "false"}}-->
<!--                    </pre>-->
                </div>
                <form class="form" @submit.prevent="submit" novalidate>
                <fieldset class="form__group">
                    <ValidationAlert :error-list="errors.collect('server')"></ValidationAlert>

                    <div class="form__group">
                        <input id="activityName" name="activityName" class="form__control" v-model="formData.activityName"
                               placeholder="Enter a name for your Activity..." v-validate required />
                        <label for="activityName" class="form__label">Activity name</label>
                        <div class="form__validation">{{ errors.first('activityName') }}</div>
                    </div>

                    <!-- Start Date -->
                    <template v-if="formData.start.dateTimeString !== '' && formData.end.dateTimeString !== ''">
                        <FormControlDatetimePicker v-model="formData.start.dateTimeString" :default-value="startDate" :min-date="eventStartDate" :max-date="eventEndDate"  label="Activity Start Date"></FormControlDatetimePicker>
                        <div class="form__group" v-if="!showIndepthEndDateSelector">
                            <DurationDropdown
                                name="duration"
                                v-model="duration"
                                @input="updateDuration"
                            />
                        </div>
                        <FormControlDatetimePicker v-else v-model="formData.end.dateTimeString" :default-value="endDate" :min-date="eventStartDate" :max-date="eventEndDate" label="Activity End Date"></FormControlDatetimePicker>
                        <button class="dummy-link" type="button" @click="showIndepthEndDateSelector = !showIndepthEndDateSelector">{{ !showIndepthEndDateSelector ? "Manually enter date" : "Select duration" }}</button>
                    </template>
                    <div class="loading" v-else>
                        <Spinner :height="40" :width="40"/>
                    </div>

                    <!-- Radio true/false button whether to show the date or not -->
                    <div class="form__group">
                        <div class="toggle-group">
                            <input id="show-date" name="showDate" class="toggle" type="radio" :value="true" v-model="formData.showDate" v-validate required :checked="formData.showDate === true" />
                            <label for="show-date" class="toggle">Yes</label>
                            <input id="hide-date" name="showDate" class="toggle" type="radio" :value="false" v-model="formData.showDate" v-validate required :checked="formData.showDate === false" />
                            <label for="hide-date" class="toggle">No</label>
                        </div>
                        <label class="form__label">Show date on the app?</label>
                        <div class="form__validation">{{ errors.first('showDate') }}</div>
                    </div>

                    <!-- Event Dropdown -->
                    <DealTypeDropdown name="dealType" v-model="formData.activityType" label="Select deal type" v-validate="'required'" />

                    <div v-if="showRegistration" class="form__group">
                        <div class="toggle-group">
                            <div class="toggle-group">
                                <input id="registrable" name="registrable" class="toggle" type="radio" :value="true" v-model="formData.registrable" v-validate required :checked="formData.registrable ===  true" />
                                <label for="registrable" class="toggle">Yes</label>
                                <input id="not-registrable" name="registrable" class="toggle" type="radio" :value="false" v-model="formData.registrable" v-validate required :checked="formData.registrable === false" />
                                <label for="not-registrable" class="toggle">No</label>
                            </div>
                        </div>
                        <label class="form__label">Is registrable?</label>
                        <div class="form__validation">{{ errors.first('registrable') }}</div>
                    </div>

                    <div class="form__group">
                    <textarea id="activityDescription" name="activityDescription" class="form__control"
                              v-model="formData.activityDescription"
                              placeholder="Enter a description for your Activity..." v-validate>
                    </textarea>
                        <label for="activityDescription" class="form__label">Activity description</label>
                        <div class="form__validation">{{ errors.first('activityDescription') }}</div>
                    </div>

                    <div>
                        <FormControlUser
                            name="chairpeople"
                            v-model="formData.chairpeople"
                            label="Chair People"
                            :multiple="true"
                        >
                        </FormControlUser>
                        <div class="form__validation">{{ errors.first('chairpeople') }}</div>
                    </div>

                    <div class="form__group">
                        <div class="form__validation">{{ errors.first('activityLocation') }}</div>
                        <div class="form__location-wrapper">
                            <div>
                                <label for="activityLocation" class="form__label">Activity location</label>
                                <div class="form__location">
                                    <input id="activityLocation" name="activityLocation" class="form__control" v-model="formData.activityLocation"
                                           placeholder="Enter a location for your Activity..." v-validate required />
                                    <button type="button" @click="onLocationChanged" class="btn btn--primary">Find Location</button>
                                </div>
                            </div>
                            <div class="form__button-wrapper">
                                <button v-if="hotel" type="button" class="form__from-hotel dummy-link" @click="setActivityFromHotel">Or from hotel...</button>
                                <button type="button" class="form__location-manual dummy-link" @click="toggleManualLocation">Manual Address</button>
                            </div>
                        </div>
                    </div>

                    <div class="form__address" v-if="showLocationDetails && !manualLocation">
                        <span v-if="formData.website" class="form__detail">Website: <a :href="formData.website" target="_blank" rel="noopener noreferrer">{{ formData.website }}</a></span>
                        <span v-if="formData.phoneNumber" class="form__detail">Phone Number: {{ formData.phoneNumber }}</span>
                        <span v-if="formData.address" class="form__detail">Address: {{ formData.address }}</span>
                        <span v-if="formData.lat && formData.lng" class="form__detail">Lat/Lng: {{ formData.lat }}, {{ formData.lng }}</span>
                        <span v-if="formData.rating" class="form__detail">Rating: {{ formData.rating }}</span>
                        <span v-if="formData.directionUrl" class="form__detail">Direction URL: <a :href="formData.directionUrl" target="_blank" rel="noopener noreferrer">{{ formData.directionUrl }}</a></span>
                        <span v-if="formData.activityRoom" class="form__detail">Room: {{ formData.activityRoom }}</span>
                        <div v-if="formData.activityBackgroundImage" class="form__background">
                            <img :src="formData.activityBackgroundImage" alt="Background Image"/>
                        </div>
                    </div>

                    <div v-if="manualLocation" class="form__location-details">
                        <div class="form__group">
                            <input id="website" name="website" class="form__control" v-model="formData.website"
                                   placeholder="Enter a website for your Activity..." v-validate />
                            <label for="website" class="form__label">Activity website</label>
                            <div class="form__validation">{{ errors.first('website') }}</div>
                        </div>

                        <div class="form__group">
                            <input id="phoneNumber" name="phoneNumber" class="form__control" v-model="formData.phoneNumber"
                                   placeholder="Enter a phone number for your Activity..." v-validate />
                            <label for="phoneNumber" class="form__label">Activity phone number</label>
                            <div class="form__validation">{{ errors.first('phoneNumber') }}</div>
                        </div>

                        <div class="form__group">
                            <input id="lat" name="lat" type="number" class="form__control" v-model="formData.lat"
                                   placeholder="Enter a latitude for your Activity..." v-validate />
                            <label for="lat" class="form__label">Activity latitude</label>
                            <div class="form__validation">{{ errors.first('lat') }}</div>
                        </div>

                        <div class="form__group">
                            <input id="lng" name="lng" type="number" class="form__control" v-model="formData.lng"
                                   placeholder="Enter a longitude for your Activity..." v-validate />
                            <label for="lng" class="form__label">Activity longitude</label>
                            <div class="form__validation">{{ errors.first('lng') }}</div>
                        </div>

                        <div class="form__group">
                            <input id="rating" name="rating" type="number" min="0.0" max="5.0" step="0.1" class="form__control" v-model="formData.rating"
                                   placeholder="Enter a rating for your Activity..." v-validate />
                            <label for="rating" class="form__label">Activity rating</label>
                            <div class="form__validation">{{ errors.first('rating') }}</div>
                        </div>

                        <div class="form__group">
                            <input id="address" name="address" class="form__control" v-model="formData.address"
                                   placeholder="Enter an address for your Activity..." v-validate />
                            <label for="address" class="form__label">Activity address</label>
                            <div class="form__validation">{{ errors.first('address') }}</div>
                        </div>

                        <div class="form__group">
                            <input id="directionUrl" name="directionUrl" class="form__control" v-model="formData.directionUrl"
                                   placeholder="Enter a direction URL for your Activity..." v-validate />
                            <label for="directionUrl" class="form__label">Activity direction URL</label>
                            <div class="form__validation">{{ errors.first('directionUrl') }}</div>
                        </div>
                    </div>

                    <div class="form__group">
                        <input id="activityRoom" name="activityRoom" class="form__control" v-model="formData.activityRoom"
                               placeholder="Enter a room for your Activity..." v-validate />
                        <label for="activityRoom" class="form__label">Activity room</label>
                        <div class="form__validation">{{ errors.first('activityRoom') }}</div>
                    </div>

                    <div class="form__group">
                        <FileUpload :multiple="false" v-model="formData.background.uuid" name="background" label="Background Image">
                        </FileUpload>
                    </div>

                    <div class="form__group form__group--submit">
                        <button type="submit" class="btn btn--primary">Save</button>
                    </div>
                </fieldset>
            </form>
            </template>
        </template>
    </LayoutForm>
</template>

<script>

import LayoutForm from '../../Layout/LayoutForm.vue';
import Form from '../../Form/Form';
import ValidationAlert from '../../ValidationAlert.vue';
import API from '@api';
import EventDropdown from '../../Activities/EventDropdown';
import DealTypeDropdown from '../DealTypeDropdown/index.vue';
import FormControlDatetimePicker from '../../Form/Control/FormControlDatetimePicker.vue';
import FileUpload from '../../Form/FileUpload.vue';
import FormControlUser from '../../Form/Control/FormControlUser.vue';
import Spinner from '@components/Spinner.vue';
import { ActivityTypes, ActivityTypesArray } from '../../../resources/ActivityTypes';
import DurationDropdown from '@components/Activities/DurationDropdown/index.vue';
import { addMinutes, format } from 'date-fns';

const defaultDuration = 60; // in minutes

export default {
    name: "ActivityForm",
    mixins: [Form],
    components: {
        FormControlUser,
        FileUpload,
        FormControlDatetimePicker,
        DealTypeDropdown,
        LayoutForm,
        ValidationAlert,
        EventDropdown,
        Spinner,
        DurationDropdown
    },
    props: {
        eventId: {
            type: Number,
            required: true,
        },
        // passed from activity preview...
        start: {
            type: Array,
            required: false,
        }
    },
    data() {
        return {
            error: false,
            showIndepthEndDateSelector: true,
            duration: null,
            hotel: null,
            showLocationDetails: false,
            manualLocation: false,
            formData: {
                activityName: '',
                activityDescription: '',
                activityLocation: '',
                locationObject: Object,
                website: '',
                phoneNumber: '',
                lat: 0.0,
                lng: 0.0,
                showDate: true,
                directionUrl: '',
                start: {
                    dateTimeString: '',
                },
                end: {
                    dateTimeString: '',
                },
                event: {
                    id: this.eventId,
                    start: {
                        dateTimeString: '',
                    },
                    end: {
                        dateTimeString: '',
                    },
                },
                address: '',
                activityBackgroundImage: '',
                activityRoom: '',
                eventId: -1,
                activityType: -1,
                rating: 0.0,
                registrable: false,
                background: {
                    url: "",
                    uuid: "",
                    filename: "",
                },
                backgroundUrl: "",
                chairpeople: [],
            },
        }
    },
    mounted() {
        if (this.id) {
            this.showLocationDetails = true;
        }

        this.fetchEvent();
    },
    computed: {
        eventStartDate() {
            if(this.formData.event.start.dateTimeString) {
                return new Date(this.formData.event.start.dateTimeString);
            }

            return null;
        },
        eventEndDate() {
            if(this.formData.event.end.dateTimeString) {
                return new Date(this.formData.event.end.dateTimeString);
            }

            return null;
        },
        startDate() {
            console.log("start:", this.formData.event.start);
            return this.formData.start && this.formData.start.dateTimeString
                ? new Date(this.formData.start.dateTimeString)
                : "";
        },
        endDate() {
            return this.formData.end && this.formData.end.dateTimeString
                ? new Date(this.formData.end.dateTimeString)
                : "";
        },
        showRegistration() {
            if(this.formData.activityType === -1) {
                return false;
            }

            const activityType = ActivityTypesArray.find(type => type.id === this.formData.activityType);
            // search activity type by id
            return !activityType.registrableByDefault && activityType.isAgendaItem;
        }
    },
    methods: {
        fetchEvent() {
            if (this.eventId) {
                this.formData.eventId = this.eventId;
                this.$wait.start('event');
                API.getEventByIdForm(this.eventId)
                    .then((res) => {
                        console.log("Res: ", res);
                        this.formData.event = res;
                        this.hotel = res.hotel;

                        // get start, end from activity if this.id is set otherwise set here.
                        if (this.id) {
                            // TODO: fetch start and end dates from here...
                        } else {
                            const start = this.start ? { ...this.start } : { ...res.start };
                            this.formData.start = start;
                            this.formData.end = {
                                ...start,
                                dateTimeString: format(
                                    addMinutes(new Date(start.dateTimeString), defaultDuration),
                                    "yyyy-MM-dd HH:mm:ss"
                                )
                            };
                        }

                        this.formData.startDate = { ...res.start }
                        this.formData.endDate = { ...res.end };
                    })
                    .catch((err) => this.error = true)
                    .finally(() => this.$wait.end('event'));
            } else {
                this.error = true;
            }
        },
        toggleManualLocation() {
          this.manualLocation = !this.manualLocation;
        },
        updateValue(event) {
            console.log("Got value", event);
            this.$emit('input', event);
        },
        updateDuration(duration) {
            if (this.startDate && duration !== -1) {
                this.formData.end.dateTimeString = format(addMinutes(this.startDate, duration), "yyyy-MM-dd HH:mm:ss");
            }
        },
        fetchResource(id) {
            const activity = API.getActivity(id);
            console.log(activity);
            return activity;
        },
        setActivityFromHotel() {
            if (this.hotel) {
                this.formData.activityLocation = this.hotel.activityLocation;
                this.formData.website = this.hotel.website;
                this.formData.phoneNumber = this.hotel.phoneNumber;
                this.formData.lat = this.hotel.lat;
                this.formData.lng = this.hotel.lng;
                this.formData.address = this.hotel.address;
                this.formData.rating = this.hotel.rating;
                this.formData.directionUrl = this.hotel.directionUrl;
                this.formData.activityRoom = this.hotel.activityRoom;
                if(this.hotel.activityBackgroundImage) {
                    this.formData.activityBackgroundImage = this.hotel.activityBackgroundImage;
                }
                if(this.hotel.background) {
                    this.formData.background = this.hotel.background;
                }
                this.showLocationDetails = true;
            }
        },
        sanitizeResource(data) {
            console.log("Sanitizing data: ", data, "for ", this.id);

            if(Array.isArray(data.sectors)) {
                data.sectors = data.sectors.map(sector => sector.id);
            }

            if(typeof data.start === 'object') {
                data.fixedStartTime = data.start
            }

            if(typeof data.end === 'object') {
                data.fixedEndTime = data.end
            }

            if(data.showDate && data.showDate === 1) {
                data.showDate = true;
            } else {
                data.showDate = false;
            }

            if(data.chairpeople && Array.isArray(data.chairpeople)) {
                data.chairpeople = data.chairpeople.map(chairperson => chairperson.id);
            }

            console.log("background : ", data.background);

            // Not sure how the other forms are updating data, but this doesn't seem to do it without this line
            this.formData = data;

            if (data.background) {
                this.$store.commit('selectCache/addAttachment', data.background);
            } else {
                data.background = {
                    url: "",
                    uuid: "",
                    filename: "",
                }
            }

            return data;
        },
        onLocationChanged(event) {
            this.$validator.validate('activityLocation').then((result) => {
                API.getGeoLocation(this.formData.activityLocation).then((response) => {
                    console.log(response);
                    this.formData.website = response.website;
                    this.formData.phoneNumber = response.phoneNumber;
                    this.formData.lat = response.lat;
                    this.formData.lng = response.lng;
                    this.formData.address = response.address;
                    this.formData.rating = response.rating;
                    this.formData.directionUrl = response.directionUrl;
                    if(response.attachment) {
                        console.log("Got attachment", response.attachment);
                        this.formData.background = response.attachment;
                    }
                    if (response.backgroundUrl) {
                        this.formData.backgroundUrl = response.backgroundImage;
                    }
                    this.showLocationDetails = true;
                });
            });
        },
        eventChanged(event) {
            this.formData.event = event;
        },
        submit() {
            this.$validator.validateAll().then((result) => {
                if (!result) {
                    return;
                }

                let req = this.id
                    ? API.updateActivity(this.id, this.formData)
                    : API.createActivity(this.formData);

                req.then((response) => {
                    console.log(response);
                    this.$router.push({
                        name: 'view-activity',
                        params: {activity_id: response.id}
                    });
                })
                .catch(error => {
                    API.mapServerValidation(this.errors, this.$validator)
                })
            });
        }

    }
}
</script>

<style scoped lang="scss">
    .form__location {
        position: relative;
        display: flex;
        align-items: center;
        gap: 1.5rem;
        justify-content: space-between;
        order: 2;
    }

    .form__background {
        img {
            width: 100%;
        }
    }

    .form__group {
        width: 100%;

        & > div {
            width: 100%;
        }
    }

    .debug {
        max-width: 100%;
        display: block;
    }

    .form__image {
        width: 20rem;
        height: 20rem;
        object-fit: cover;
        border-radius: 1rem;
        margin-bottom: 2rem;
        margin-top: 0.5rem;
    }

    .loading {
        display: flex;
        justify-content: center;
        align-content: center;
        min-height: 10rem;
    }

    .form__title {
        span {
            display: block;

            & + span {
                margin-top: 0.5rem;
            }
        }
    }

    .dummy-link {
        margin-top: -2rem;
        margin-bottom: 3rem;
    }

    .form__location-wrapper {
        &:has(.form__from-hotel) {
            display: flex;
            gap: 1rem;
            flex-direction: column;

            .form__label {
                display: block;
            }
        }

        .dummy-link {
            margin-bottom: 0;
            margin-top: 0;
        }
    }

    .form__button-wrapper {
        display: flex;
        justify-content: space-between;
    }

    .form__address {
        font-style: italic;
        color: #657787;
        font-family: Axiforma, sans-serif;
        font-size: 1.2rem;
        line-height: 1.4rem;
        font-weight: 300;
        letter-spacing: 0.043rem;

        .form__detail {
            display: block;
            margin-bottom: 0.2rem;
        }
    }

    .form__group--submit {
        .btn {
            flex: 0 0 50%;
        }
    }
</style>
